// Reads the payload of the access token returned by /api/login. The token is
// only decoded, not verified — the backend verifies it on every request.

export type PropertyType = "hotel" | "residential";

export interface PropertyData {
  _id?: string;
  name?: string;
  type?: string;
  wifi_password?: string;
  reception_number?: string;
  property_logo_path?: string;
  property_app_background_path?: string;
  property_video_path?: string;
  [key: string]: any;
}

export interface UserData {
  _id?: string;
  fullName?: string;
  screen_type?: string;
  screen_number?: string;
  package_name?: string;
  property_data?: PropertyData;
  [key: string]: any;
}

export interface AccessTokenPayload {
  baas_device_id?: string;
  user_data?: UserData;
  exp?: number;
  [key: string]: any;
}

export const decodeAccessToken = (token?: string | null): AccessTokenPayload | null => {
  if (!token) return null;
  const part = token.split(".")[1];
  if (!part) return null;
  try {
    // base64url -> base64, padded, then decoded as UTF-8 so names with
    // accented letters survive
    const b64 = part.replace(/-/g, "+").replace(/_/g, "/").padEnd(Math.ceil(part.length / 4) * 4, "=");
    const bytes = Uint8Array.from(atob(b64), (c) => c.charCodeAt(0));
    return JSON.parse(new TextDecoder().decode(bytes));
  } catch (e) {
    console.warn("Could not decode access token", e);
    return null;
  }
};

// Anything other than "hotel" (including a missing type) is treated as
// residential, which keeps the existing login flow.
export const getPropertyType = (payload: AccessTokenPayload | null): PropertyType =>
  payload?.user_data?.property_data?.type?.toLowerCase() === "hotel" ? "hotel" : "residential";

// Same, from the token the licence screen saved to localStorage after login
export const getStoredTokenPayload = () => decodeAccessToken(localStorage.getItem("access_token"));
export const getStoredPropertyType = () => getPropertyType(getStoredTokenPayload());
